module.exports = {"630121100":"桥头镇","630121101":"城关镇","630121102":"塔尔镇","630121103":"东峡镇","630121104":"黄家寨镇","630121105":"长宁镇","630121106":"景阳镇","630121107":"多林镇","630121108":"新庄镇","630121200":"青林乡","630121201":"青山乡","630121202":"逊让乡","630121203":"极乐乡","630121204":"石山乡","630121205":"宝库乡","630121206":"斜沟乡","630121207":"良教乡","630121208":"向化藏族乡","630121209":"桦林乡","630121210":"朔北藏族乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/630121.json
// module id = 2983
// module chunks = 0